import React, { useContext } from "react";
import { Text, BlockStack, InlineStack } from "@shopify/polaris";
import ConsignmentShip from "app/setup/modules/operator/features/_fulfillment/generic/consignmentShip/consignmentShip";
import { FulfillmentContext } from "app/setup/modules/operator/features/_fulfillment/context";

const HybridConsignmentShip = () => {
  const { cms } = useContext(FulfillmentContext);
  return (
    <div>
      <BlockStack gap="10">
        <InlineStack>
          <Text variant="headingMd" as="h2">
            {cms("hybrid.consignmentShip.title")}
          </Text>
          {/* 
            <Link onClick={() => learnMore(cms("hybrid.consignmentShip.title"), cms("hybrid.consignmentShip.title"))}>
              {cms("common.learnMore")}
            </Link>
           */}
          <br />
          <Text as="span" tone="subdued">
            {cms("hybrid.consignmentShip.description")}
          </Text>
        </InlineStack>
      </BlockStack>
      <br />
      <ConsignmentShip method="defaultConsignmentShip" value="consignmentShip" />
    </div>
  );
};
export default HybridConsignmentShip;
